import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const workOrderSummaryReportTodo = createAsyncThunk('workOrderSummaryReport', async ({ params, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `reports/work-order-summary`,
            params: {
                from_date: params?.from_date,
                to_date: params?.to_date,
                service_department_id: params?.service_department_id || undefined,
                maintanance_type: params?.maintanance_type || undefined,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const workOrderSummaryReportSlice = createSlice({
    name: 'workOrderSummaryReport',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(workOrderSummaryReportTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = null
            }
        });
        builder.addCase(workOrderSummaryReportTodo.rejected, () => { })
    }
})

export default workOrderSummaryReportSlice.reducer;
